import { lazyWithPreload } from '../../navigation';

export const TriageScreen = lazyWithPreload(() => import('./TriageScreen.lazy'));

export { FindingIdentifiedLabel } from './FindingIdentifiedLabel';
export { FindingPagesList } from './FindingPagesList';
export { FindingProcessBlock } from './FindingProcessBlock';
export {
    useIsAnyFindingProcessingForSite,
    useIsProcessingFinding,
    useIsTriggeringChangeRequestsForFinding,
    useTriggerChangeRequestsForFinding,
} from './TriageContext';
export type { TriageScreenProps } from './TriageScreen.lazy';
export {
    TriggerChangeRequestsButton,
    useTriggerChangeRequestsAction,
} from './TriggerChangeRequestsButton';
export { useFindingConnectors } from './useFindingConnectors';
